import { render, staticRenderFns } from "./BottomSheetCreate.vue?vue&type=template&id=474a0b32&scoped=true&"
import script from "./BottomSheetCreate.vue?vue&type=script&lang=js&"
export * from "./BottomSheetCreate.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetCreate.vue?vue&type=style&index=0&id=474a0b32&scoped=true&lang=css&"
import style1 from "./BottomSheetCreate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a0b32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBottomNavigation,VBtn,VCard,VCardText,VDialog,VIcon,VStepper,VStepperContent})
